<template>
    <div class="manutencao-container">
        <div class="manutencao-conteudo">
            <font-awesome-icon :icon="'wrench'" class="manutencao-icone" />
            <h1>Estamos em Manutenção</h1>
            <p>
                Desculpe, esta área do site está temporariamente indisponível devido a manutenção. Estamos trabalhando para 
                resolver isso o mais rápido possível. Por favor, volte mais tarde.
            </p>
            <p>Agradecemos a sua compreensão.</p>
            <button class="btn btn-default" @click="voltar">
                <font-awesome-icon :icon="'arrow-left'" />
                Voltar
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Manutencao',
    methods: {
        voltar() {
            this.$router.back()
        }
    }
}
</script>

<style scoped>
.manutencao-container {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-height: 60vh;
    color: #333;
}

.manutencao-conteudo {
    max-width: 700px;
    padding: 20px;
}

.manutencao-icone {
    font-size: 5rem;
    color: #00615c;
    margin-bottom: 20px;
}

h1 {
    font-size: 3.5rem;
    color: #00615c;
    margin-bottom: 15px;
}

p {
    font-size: 1.5rem;
    line-height: 1.6;
    margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/public/manutencao/index.vue